/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/RestConfigEditDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestConfigEditDialogTestIds = {
  authTypeChangeWarning: "auth-type-change-warning",
  authTypeOptionAwsSigv4: "auth-type-option-aws-sigv4",
  authTypeOptionGoogleSaJwt: "auth-type-option-google-sa-jwt",
  authTypeOptionMutualTls: "auth-type-option-mutual-tls",
  authTypeOptionNtlmKerberos: "auth-type-option-ntlm-kerberos",
  authTypeOptionSignedRequest: "auth-type-option-signed-request",
  btnCancelRestConfig: "btn-cancel-rest-config",
  btnCancelScimConfig: "btn-cancel-scim-config",
  btnSaveRestConfig: "btn-save-rest-config",
  btnSaveScimConfig: "btn-save-scim-config",
  googleSaSectionHelp: "google-sa-section-help",
  inputAwsAccessKeySecretRef: "input-aws-access-key-secret-ref",
  inputAwsRegion: "input-aws-region",
  inputAwsSecretKeySecretRef: "input-aws-secret-key-secret-ref",
  inputAwsService: "input-aws-service",
  inputClientCertSecretRef: "input-client-cert-secret-ref",
  inputClientKeySecretRef: "input-client-key-secret-ref",
  inputGoogleDelegatedUser: "input-google-delegated-user",
  inputGoogleSaEmail: "input-google-sa-email",
  inputGoogleSaKeySecretRef: "input-google-sa-key-secret-ref",
  inputGoogleTokenScope: "input-google-token-scope",
  inputItemsJsonPath: "input-items-json-path",
  inputKerberosKeytabSecretRef: "input-kerberos-keytab-secret-ref",
  inputKerberosPrincipal: "input-kerberos-principal",
  inputKerberosRealm: "input-kerberos-realm",
  inputSigningHeaderTemplate: "input-signing-header-template",
  inputSigningKeySecretRef: "input-signing-key-secret-ref",
  inputTruststoreSecretRef: "input-truststore-secret-ref",
  kerberosSectionHelp: "kerberos-section-help",
  mtlsSectionHelp: "mtls-section-help",
  responseFormatCsv: "response-format-csv",
  responseFormatJson: "response-format-json",
  responseFormatText: "response-format-text",
  responseFormatXml: "response-format-xml",
  restApiKeySecretRef: "rest-api-key-secret-ref",
  restClientSecretRef: "rest-client-secret-ref",
  restPasswordSecretRef: "rest-password-secret-ref",
  restTokenSecretRef: "rest-token-secret-ref",
  selectPaginationStyle: "select-pagination-style",
  selectResponseFormat: "select-response-format",
  selectRestAuthType: "select-rest-auth-type",
  selectSigningAlgorithm: "select-signing-algorithm",
  signedRequestSectionHelp: "signed-request-section-help",
  sigv4SectionHelp: "sigv4-section-help",
  signingAlgorithmOption: (alg_toLowerCase: string) => `signing-algorithm-option-${alg_toLowerCase}`,
  signingAlgorithmOptionPrefix: () => "signing-algorithm-option-" as TestIdPrefix
} as const;
